import React from 'react';
import PropTypes from 'prop-types';
import useTransferItem from '../../../utils/useTransferItem';
import TransportsStepper from '@afosto/app-components-react/TransportsStepper';

const TransportsFormatter = ({ transfer, claimId }) => {
  const [transferItem] = useTransferItem(transfer, claimId);

  return (
    <TransportsStepper
      transports={transferItem?.transports}
      routes={transferItem?.route}
      orientation="horizontal"
      maxConnectorWidth={30}
      compact
    />
  );
};

TransportsFormatter.propTypes = {
  transfer: PropTypes.string,
  claimId: PropTypes.string,
};

TransportsFormatter.defaultProps = {
  transfer: undefined,
  claimId: undefined,
};

export default TransportsFormatter;
